// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "notification__wrapper-5dKLe";
var _4 = "notification__global-1hYXd";
export { _1 as "__esModule", _2 as "mobile", _3 as "notification__wrapper", _4 as "notification__global" }
export default { "__esModule": _1, "mobile": _2, "notification__wrapper": _3, "notification__global": _4 }
